import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAZ02aGoce9eFWa2KO_CLicaEt2gac6LZk",
  authDomain: "solo-autos1.firebaseapp.com",
  projectId: "solo-autos1",
  storageBucket: "solo-autos1.firebasestorage.app",
  messagingSenderId: "984228432991",
  appId: "1:984228432991:web:3e9c065f22ffd8b12c9fea",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
